import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import App from './containers/App';
import prodStore from './store/configureStore.prod';
import devStore from './store/configureStore.dev';

const store = process.env.NODE_ENV === 'production' ? prodStore() : devStore();

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);
